// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 查询用户权益领取流程信息 GET /broker-open-equity/apply/flow-info */
export async function brokerOpenEquityApplyFlowInfoUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultBrokerOpenEquityApplyFlowInfoResp>(
    '/broker-open-equity/apply/flow-info',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 查询用户权益领取信息 GET /broker-open-equity/apply/info */
export async function brokerOpenEquityApplyInfoUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultBrokerOpenEquityApplyInfoResp>('/broker-open-equity/apply/info', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 阅读开户权益协议 POST /broker-open-equity/apply/read-agreement */
export async function brokerOpenEquityApplyReadAgreementUsingPOST(
  body: API.BrokerOpenEquityReadAgreementReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/broker-open-equity/apply/read-agreement', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 用户量化权益领取记录 GET /broker-open-equity/customer-apply-list */
export async function brokerOpenEquityCustomerApplyListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.brokerOpenEquityCustomerApplyListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListBrokerOpenEquityCustomerApplyResp>(
    '/broker-open-equity/customer-apply-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 提交用户权益包领取回访信息 POST /broker-open-equity/feedback/submit */
export async function brokerOpenEquityFeedbackSubmitUsingPOST(
  body: API.BrokerOpenEquityFeedbackReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/broker-open-equity/feedback/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 权益包领取签字 POST /broker-open-equity/sign */
export async function brokerOpenEquitySignUsingPOST(
  body: API.BrokerOpenEquitySignReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultESignStatusResp>('/broker-open-equity/sign', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询权益包领取签字信息 GET /broker-open-equity/sign/status */
export async function brokerOpenEquitySignStatusUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.brokerOpenEquitySignStatusUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultESignStatusResp>('/broker-open-equity/sign/status', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 提交权益包申请 POST /broker-open-equity/submit */
export async function brokerOpenEquitySubmitUsingPOST(
  body: API.BrokerOpenEquityApplyReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/broker-open-equity/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
